import { TYPE_CODES } from '@/modules/transactions/_constants/constants'
import _transactionsIndexViewShared from '@/modules/transactions/_mixins/_transactionsIndexViewShared'
import Multiselect from 'vue-multiselect'
const CreateExportationFlowModal = () => import('../_components/CreateExportationFlowModal.vue')

export default {
  components: {
    Multiselect,
    CreateExportationFlowModal
  },
  mixins: [
    _transactionsIndexViewShared
  ],
  data () {
    return {
      showCreateExportationFlowFlag: false,
      exportationFlowSelected: undefined,
      tableName: 'transactionsExport',
      flowId: undefined,
      tabs: [],
      tab: ''
    }
  },
  computed: {
    filters () {
      return { ...this.$store.getters['TransactionsStore/filters'] }
    },
    exportationFlows () {
      return this.$store.getters['ExportStore/exportationFlows']
    },
    exportationFlow () {
      return this.$store.getters['ExportStore/exportationFlows'].length > 0 ? this.$store.getters['ExportStore/exportationFlow'] : {}
    }
  },
  methods: {
    exportReturnLink () {
      if (this.exportationFlowSelected.filters?.filter['type.code']?.includes(TYPE_CODES.EXPENSE)) {
        return '/export/expenses'
      } else if (this.exportationFlowSelected.filters?.filter['type.code']?.includes(TYPE_CODES.NORMAL)) {
        return '/export/transactions'
      } else {
        return '/export/all'
      }
    },
    showTabs () {
      this.tabs = []
      let typeCode = this.exportationFlow.filters?.filter['type.code']
      if (typeCode?.includes(TYPE_CODES.EXPENSE)) {
        this.tabs.push({
          id: 3,
          name: 'expenses',
          to: 'expenses',
          type: TYPE_CODES.EXPENSE
        })
      } else if (typeCode?.includes(TYPE_CODES.NORMAL)) {
        this.tabs.push({
          id: 2,
          name: 'transactions',
          to: 'transactions',
          type: TYPE_CODES.NORMAL
        })
      } else {
        this.tabs.push({
          id: 1,
          name: 'all',
          to: 'all'
        }, {
          id: 2,
          name: 'transactions',
          to: 'transactions',
          type: TYPE_CODES.NORMAL
        }, {
          id: 3,
          name: 'expenses',
          to: 'expenses',
          type: TYPE_CODES.EXPENSE
        })
      }
    },
    showCreateExportationFlow (newFlow) {
      this.showFilterModalFlag = false
      this.flowId = newFlow ? undefined : this.exportationFlowSelected.id
      this.showCreateExportationFlowFlag = true
    },
    async setExportationFlow (exportationFlow) {
      this.showCreateExportationFlowFlag = false
      this.exportationFlowSelected = exportationFlow
      await this.$store.dispatch('ExportStore/fetchExportationFlow', this.exportationFlowSelected.id)
      await this.fetchTransactions()
      if (this.exportationFlowSelected.filters?.filter['type.code']?.includes(TYPE_CODES.EXPENSE)) {
        this.$router.push('/export/expenses')
        this.tab = TYPE_CODES.EXPENSE
      } else if (this.exportationFlowSelected.filters?.filter['type.code']?.includes(TYPE_CODES.NORMAL)) {
        this.$router.push('/export/transactions')
        this.tab = TYPE_CODES.NORMAL
      } else {
        this.tab = TYPE_CODES.ALL
        this.$router.push('/export/all')
      }
      this.showTabs()
    },
    async fetchTransactions (event) {
      let defaultFilters = Object.assign({}, this.exportationFlow?.filters?.filter)
      if (this.tab === TYPE_CODES.ALL) {
        delete defaultFilters['type.code']
      }
      if (this.exportationFlow?.incremental) {
        defaultFilters.notIncludeInExportSettingId = this.exportationFlowSelected.id
      }
      if (defaultFilters.users) {
        defaultFilters['card.user.id'] = defaultFilters.users.map(item => item.id)
        this.$store.dispatch('FiltersStore/TransactionsStore/addUserFilters', defaultFilters.users)
      } else {
        this.$store.dispatch('FiltersStore/TransactionsStore/addUserFilters', [])
      }
      if (defaultFilters.budget) {
        defaultFilters['budget.id'] = defaultFilters.budget.id
        await this.$store.dispatch('BudgetsStore/setBudgetsFilters', defaultFilters.budget)
      } else {
        await this.$store.dispatch('BudgetsStore/setBudgetsFilters', {})
      }

      let searchFilters = {}
      let force = false
      if (event && event.length >= 3) {
        searchFilters.query = event
      }

      let filters = event ? { ...defaultFilters, ...searchFilters } : { ...defaultFilters, ...searchFilters, ...this.parseQueryParams() }
      if (event && event.force) {
        force = true
      }

      await this.$store.dispatch('TransactionsStore/setTransactionsFilters', {
        filters: filters,
        force: force
      })
      this.showTabs()
    }
  },
  created () {
    this.exportationFlowSelected = this.exportationFlow
    this.flowOptions = this.exportationFlows
    this.flowId = this.exportationFlow.id
  }

}
